import { IAddress } from "../models/IAddress";

export function formatAddress(address?: IAddress): string {
    if (address?.address == undefined || address?.zipCode == undefined || address?.city == undefined) {
        return "";
    }
    return `${address?.address?.trim()}, ${address?.zipCode} ${address?.city}`;
}